import { Motion, spring } from 'react-motion';
import React, { Component } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner } from '../../../shared-components/Spinner/Spinner';
import './FullPageSpinner.less';

import { SPINNER_DEFAULT_MESSAGE_TYPE } from './FullPageSpinnerConstants';

const LOCALE_PREFIX = 'layouts/master';

// This component renders in between page transitions for all countries called by the Skeleton Page
// It is calling the vxlib spinner component found in the shared components.

export class FullPageSpinner extends Component {
    static defaultProps = {
        isVisible: false,
        messageType: SPINNER_DEFAULT_MESSAGE_TYPE
    };
    static propTypes = {
        isVisible: PropTypes.bool,
        messageType: PropTypes.string
    };
    render() {
        const { isVisible, messageType } = this.props;
        const message = (
            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.${messageType}`} />
        );
        return (
            <Motion
                defaultStyle={{
                    opacityValue: 0
                }}
                style={{
                    opacityValue: isVisible ? spring(1) : spring(0)
                }}
            >
                {interpolatedStyles => (
                    <div
                        id="full-page-spinner"
                        className="full-page-spinner"
                        data-automation-id="full-page-spinner"
                        role="progressbar"
                        aria-valuetext={message}
                        aria-hidden={isVisible}
                        style={{
                            display: interpolatedStyles.opacityValue ? undefined : 'none', // set to undefined on SPINNER_OPEN & uses display:flex from .less
                            opacity: interpolatedStyles.opacityValue
                        }}
                    >
                        <div className="spinWrap">
                            <Spinner />
                            <p className="genericLoadingMessage">{message}</p>
                        </div>
                    </div>
                )}
            </Motion>
        );
    }
}

export const mapStateToProps = state => ({
    isVisible: state.spinner.isVisible,
    messageType: state.spinner.messageType
});

export default connect(mapStateToProps)(FullPageSpinner);
